/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */
// React import 
import React from "react"
import { Redirect, Switch, Route } from "react-router-dom"
import { shallowEqual, useSelector } from "react-redux"
import { Layout } from "../_metronic/layout"
import BasePage from "./BasePage"
import { Logout, AuthPage } from "./modules/Auth"
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage"
import PrivacyPolicyPage from "./modules/Auth/pages/Static/PrivacyPolicy"
import DisclaimerPage from "./modules/Auth/pages/Static/Disclaimer"

export function Routes() {
  const { isAuthorized } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.user != null,
    }),
    shallowEqual
  )

  const auth = useSelector(({ auth }) => auth, shallowEqual)

  // // const isAuthorized = false
  return (
    <Switch>
       <Route path="/privacy-policy" component={PrivacyPolicyPage} />
       <Route path="/disclaimer" component={DisclaimerPage} />
      {!isAuthorized ? (
        <Route>
          <AuthPage />
        </Route>
      ) : (
        <Redirect from="/auth" to="/" />
      )}

      <Route path="/error" component={ErrorsPage} />
      <Route path="/logout" component={Logout} />

      {!isAuthorized ? (
        <Redirect to="/auth/login" />
      ) : (
        <Layout>
          <BasePage />
        </Layout>
      )}
      {/* <Layout>
        <BasePage />
      </Layout> */}
    </Switch>
  )
}
